var toolbar = [
    {
        label: 'Formats',
        type: 'group',
        items: [{
            label: 'Size',
            type: 'size',
            items: [{
                label: 'h1',
                value: '32px'
            }, {
                label: 'h2',
                value: '20px'
            }, {
                label: 'h3',
                value: '16px',
                selected: true
            }, {
                label: 'h4',
                value: '12px'
            }]
        }, {
            type: 'separator'
        }, {
            label: 'Alignment',
            type: 'align',
            items: [{
                label: '',
                value: 'left',
                selected: true
            }, {
                label: '',
                value: 'center'
            }, {
                label: '',
                value: 'right'
            }, {
                label: '',
                value: 'justify'
            }]
        }]
    },

    {
        label: 'Text',
        type: 'group',
        items: [{
            type: 'bold',
            label: 'Bold'
        }, {
            type: 'italic',
            label: 'Italic'
        }, {
            type: 'strike',
            label: 'Strike'
        }, {
            type: 'underline',
            label: 'Underline'
        }, {
            type: 'separator'
        }, {
            type: 'link',
            label: 'Link'
        }]
    },

    {
        label: 'Blocks',
        type: 'group',
        items: [{
            type: 'bullet',
            label: 'Bullet'
        }, {
            type: 'separator'
        }, {
            type: 'list',
            label: 'List'
        }]
    }
];

export default {
    getToolbar: function () {
        return toolbar;
    }
};
